import { c as _c } from "react/compiler-runtime";
import { Label } from "@/components/ui/label";
import OptionHelpDialog from "./OptionHelpDialog";
import RequiredIndicator from "./RequiredIndicator";
interface Props {
  id?: string;
  htmlFor?: string;
  label: string;
  helper?: string;
  helpDialogId?: string;
  optional?: boolean;
}
export default function OptionLabel(t0) {
  const $ = _c(16);
  const {
    id,
    htmlFor,
    label,
    helper,
    helpDialogId,
    optional
  } = t0;
  let t1;
  if ($[0] !== optional) {
    t1 = !optional && <RequiredIndicator />;
    $[0] = optional;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <>{label}{t1}</>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const content = t2;
  let t3;
  if ($[5] !== content || $[6] !== htmlFor || $[7] !== id) {
    t3 = htmlFor ? <Label id={id} htmlFor={htmlFor} className="text-sm leading-5">{content}</Label> : <span id={id} className="flex items-center gap-2 text-sm leading-5 font-medium select-none">{content}</span>;
    $[5] = content;
    $[6] = htmlFor;
    $[7] = id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== helpDialogId || $[10] !== helper || $[11] !== label) {
    t4 = helper && helpDialogId && <OptionHelpDialog id={helpDialogId} label={label} content={helper} />;
    $[9] = helpDialogId;
    $[10] = helper;
    $[11] = label;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="flex items-center gap-1">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}